var map = {
	"./Article_0/lunbo.jpg": "n85H",
	"./Article_1/lunbo.jpg": "uVA1",
	"./Article_10/lunbo.jpg": "XBuz",
	"./Article_2/lunbo.jpg": "LB8Y"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "RZ1Q";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles ^\.\/Article_.*\/lunbo\.jpg$
// module id = RZ1Q
// module chunks = 0